import moment from 'moment';

export const datepicker_options = {
    autoclose: true,
    format: 'dd.mm.yyyy',
    language: 'de',
    zIndexOffset: 10000
};

export const daterangepicker_locale = {
    format: 'DD.MM.YYYY',
    applyLabel: "wählen",
    cancelLabel: "abbrechen",
    customRangeLabel: 'Eigener Bereich',
    daysOfWeek: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    monthNames: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};

export const daterangepicker_ranges = {
   'heute': [moment(), moment()],
   'gestern': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
   'letzte 7 Tage': [moment().subtract(6, 'days'), moment()],
   'letzte 30 Tage': [moment().subtract(29, 'days'), moment()],
   'dieser Monat': [moment().startOf('month'), moment().endOf('month')],
   'letzter Monat': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
};

export const multiselect_options = {
    numberDisplayed: 0,
    includeSelectAllOption: true,
    allSelectedText: 'alles ausgewählt',
    nonSelectedText: 'bitte wählen',
    selectAllText: 'alles auswählen',
    nSelectedText: 'ausgewählt',
    buttonClass: 'form-control',
    buttonContainer: '<div class="btn-group bootstrap-multiselect" />'
};

export const multiselect_search_options = Object.assign({}, multiselect_options, {
    enableFiltering: true,
    filterPlaceholder: "Suche",
    templates: {
        filter: '<li class="multiselect-item filter" ><div class="input-group" style="width: auto;"><span class="input-group-addon"><input class="form-control multiselect-search" type="text"></div></li>',
        filterClearBtn: '',
    }
});